import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";
import { ConfigType, Milestone } from "@/views/CarrierPerformanceView/types";
import { type TransportMode } from "@/global/types";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/carrier/performance/configs`;

const getAllConfigs = async (milestone: Milestone, transportMode: TransportMode, config?: AxiosRequestConfig) => {
  return apiBase("get", `${baseURL}`, { ...config, params: { milestone, transportMode } });
};

const getConfigByType = async (
  configType: ConfigType,
  milestone: Milestone,
  transportMode: TransportMode,
  config?: AxiosRequestConfig
) => {
  return apiBase("get", `${baseURL}/${configType}`, { ...config, params: { milestone, transportMode } });
};

const putConfigByType = async (
  configType: ConfigType,
  payload: any,
  milestone: Milestone,
  transportMode: TransportMode,
  config?: AxiosRequestConfig
) => {
  return apiBase(
    "put",
    `${baseURL}/${configType}`,
    { ...config, params: { milestone, transportMode } },
    {
      ...(payload ?? {}),
      configType
    }
  );
};

export default {
  getAllConfigs,
  getConfigByType,
  putConfigByType
};
